import { render, staticRenderFns } from "./CriarColaborador.vue?vue&type=template&id=29e3c5ab&"
import script from "./CriarColaborador.vue?vue&type=script&lang=js&"
export * from "./CriarColaborador.vue?vue&type=script&lang=js&"
import style0 from "./CriarColaborador.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports